/**
 * Created with IntelliJ IDEA.
 * User: yniran
 * Date: 08/02/14
 * Time: 19:28
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var _ = require("underscore");
    var $ = require("jquery");
    var Marionette = require("marionette");
    var ComponentManager = require("componentManager");
    var Logger = require("logger");
    var Ellipsis = require("ui.plugins/ellipsis");
    var logger = Logger.getLogger("marionette.componentManager");

    var constructor = Marionette.View.prototype.constructor;
    var bindUI = Marionette.View.prototype.bindUIElements;
    var unbindUI = Marionette.View.prototype.unbindUIElements;

    Marionette.View.prototype.constructor = function () {
        constructor.apply(this, [].slice.apply(arguments));

        if (true === Marionette.getOption(this, "withUIComponents") || !_.isUndefined(Marionette.getOption(this, "uiComponents"))) {
            var options = {
                view: this
            };
            var vent = Marionette.getOption(this, "vent");
            if (!_.isUndefined(vent)) {
                options.vent = vent;
            }

            this._uiComponentHost = ComponentManager.getHost(options);
        }

        Ellipsis.handle(this);
    };

    Marionette.View.prototype.bindUIElements = function () {
        try {

            bindUI.apply(this, [].slice.apply(arguments));

            if (!_.isUndefined(this._uiComponentHost)) {
                // In case of re-render, Clean cached items and remove all sub-views to allow re-build of the entire sub-views as if it was an initial render
                if (this.uiComponents && this.uiComponents.host$) {
                    this.uiComponents.host$.removeAll();
                    this.uiComponents = this._uiComponentsBindings;
                }

                // store the uiComponents hash in _uiComponentsBindings so they can be reset later
                // and so re-rendering the view will be able to find the bindings
                if (_.isUndefined(this._uiComponentsBindings)) {

                    this._uiComponentsBindings = this.uiComponents;

                    // get the bindings result, as a function or otherwise
                    var uiComponentsBindings = $.extend(true, {}, _.result(this, "_uiComponentsBindings"));
                    delete uiComponentsBindings.host$;

                    // Lets start from fresh
                    this.uiComponents = {};

                    // Now lets Delegate and create proxies for all the component manager methods
                    var componentsHost = this._uiComponentHost;
                    var apiComponents = this.uiComponents;

                    if (_.isUndefined(apiComponents.host$)) {
                        apiComponents.host$ = {};
                        apiComponents.host$.getLength = function () {
                            return componentsHost.getLength();
                        };
                        apiComponents.host$.restartChangesTracking = function () {
                            return componentsHost.restartChangesTracking();
                        };
                        apiComponents.host$.hasChanges = function () {
                            return componentsHost.hasChanges();
                        };
                        apiComponents.host$.registerComponentEvents = function (id, events) {
                            return componentsHost.registerComponentEvents(id, events);
                        };
                        apiComponents.host$.unregisterComponentEvents = function (id, events) {
                            return componentsHost.unregisterComponentEvents(id, events);
                        };
                        apiComponents.host$.create = function (id, options) {
                            var comp = componentsHost.createComponent(id, options);

                            if (_.isObject(comp)) {
                                apiComponents[id] = comp;

                                // Handle close of the component - we would like to remove it when it is closed
                                var closeWrapper = function () {
                                    delete apiComponents[id];
                                };
                                apiComponents[id].once("close", _.bind(closeWrapper, apiComponents.host$));
                            }

                            return comp;
                        };
                        apiComponents.host$.createAll = function (comps) {
                            var compsObj = {};

                            _.each(comps, function (options, id) {
                                var comp = apiComponents.host$.create(id, options);

                                if (_.isObject(comp)) {
                                    compsObj[id] = comp;
                                }
                            });

                            return compsObj;
                        };
                        apiComponents.host$.createAndRender = function (id, options) {
                            var comp = apiComponents.host$.create(id, options);

                            if (_.isObject(comp)) {
                                comp.render();
                            }

                            return comp;
                        };
                        apiComponents.host$.createAndRenderAll = function (comps) {
                            var compsObj = apiComponents.host$.createAll(comps);

                            if (_.isObject(compsObj)) {
                                apiComponents.host$.renderAll();
                            }

                            return compsObj;
                        };
                        apiComponents.host$.remove = function (id) {
                            var comp = componentsHost.removeComponent(id);

                            delete apiComponents[id];

                            return comp;
                        };
                        apiComponents.host$.removeAll = function () {
                            var comps = componentsHost.removeAllComponents();

                            _.each(comps, function (comp, id) {
                                if (!_.isFunction(comp)) {
                                    delete apiComponents[id];
                                }
                            });

                            return comps;
                        };
                        apiComponents.host$.toJSON = function () {
                            return componentsHost.toJSON();
                        };
                        apiComponents.host$.toJSONChanges = function () {
                            return componentsHost.toJSONChanges();
                        };
                        apiComponents.host$.callAll = function (method) {
                            return componentsHost.callAllComponents(method, _.tail(arguments));
                        };
                        apiComponents.host$.applyAll = function (method, args) {
                            return componentsHost.applyAllComponents(method, args);
                        };
                        apiComponents.host$.renderAll = function () {
                            return componentsHost.renderAllComponents();
                        };
                        apiComponents.host$.closeAll = function () {
                            return componentsHost.closeAllComponents();
                        };
                        apiComponents.host$.show = function (id) {
                            return componentsHost.show.apply(componentsHost, [].slice.apply(arguments));
                        };
                        apiComponents.host$.hide = function (id) {
                            return componentsHost.hide.apply(componentsHost, [].slice.apply(arguments));
                        };
                        apiComponents.host$.showAll = function () {
                            return componentsHost.showAll.apply(componentsHost, [].slice.apply(arguments));
                        };
                        apiComponents.host$.hideAll = function () {
                            return componentsHost.hideAll.apply(componentsHost, [].slice.apply(arguments));
                        };
                        apiComponents.host$.setEnabled = function (component, enabled) {
                            var comp = component;

                            if (_.isString(comp)) {
                                comp = componentsHost.getComponent(component);
                            }

                            if (comp && comp.setEnabled) {
                                comp.setEnabled.apply(comp, _.tail(arguments));
                            }
                        };
                        apiComponents.host$.setEnabledAll = function (enabled) {
                            var comps = componentsHost.getComponents();

                            comps.each(function (comp) {
                                apiComponents.host$.setEnabled(comp, enabled);
                            });
                        };
                    }

                    // Create the actual components using the manager proxy which will also add it to the view uiComponents map
                    if (!_.isUndefined(uiComponentsBindings)) {
                        apiComponents.host$.createAll(uiComponentsBindings);
                    }

                    if (0 < apiComponents.host$.getLength()) {
                        // Render it all
                        apiComponents.host$.renderAll();
                    }
                }
            }

        } catch (e) {
            var errMsg = "Something is wrong. Could not complete instantiating uiComponents: " + e;
            var myLogger;
            if (_.has(this, "logger")) {
                myLogger = this.logger;
            } else {
                myLogger = logger;
            }
            myLogger.error(errMsg,"marionetteComponentManager:bindUIElements",{caughtEx: e, myObj: this});
            myLogger.graph({name: "marionetteComponentManager:bindUIElements:exception"});
        }

    };

    Marionette.View.prototype.unbindUIElements = function () {
        try {
            if (!_.isUndefined(this.uiComponents)) {
                var host = this.uiComponents.host$;

                delete this.uiComponents.host$;
                if (0 < host.getLength()) {
                    host.closeAll();
                }

                // In case there are left overs (usually will be undefined)
                if (!_.isUndefined(this.uiComponents)) {
                    // delete all of the existing uiComponents bindings
                    _.each(this.uiComponents, function (component, name) {
                        delete this.uiComponents[name];
                    }, this);
                }

                // reset the uiComponents element to the original bindings configuration
                this.uiComponents = this._uiComponentsBindings;
                delete this._uiComponentsBindings;
            }

            unbindUI.apply(this, [].slice.apply(arguments));

        }
        catch (e) {
            var errMsg = "Something is wrong. Could not complete closing uiComponents: " + e;
            var myLogger;
            if (_.has(this, "logger")) {
                myLogger = this.logger;
            } else {
                myLogger = logger;
            }

            myLogger.error(errMsg,"marionetteComponentManager:unbindUIElements",{caughtEx: e, myObj: this});
            myLogger.graph({name: "marionetteComponentManager:unbindUIElements:exception"});
        }
    };
});
